import {
  IFileGateway,
  IRetailerGateway,
  PresenterFunc,
  UpdaterFunc,
} from '@/core/interface';
import { CreateRetailer, UpdateRetailer, RemoveRetailer } from '@/core/usecase';
import { Retailer } from '@/core/entity';

export class RetailerController {
  constructor(
    private readonly fileGw: IFileGateway,
    private readonly retailerGw: IRetailerGateway,
  ) { }

  public create(
    name: string,
    country: string,
    desId: string,
    file: File,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new CreateRetailer(this.fileGw, this.retailerGw);

    useCase.execute(name, country, desId, file, presenter, updater);
  }

  public remove(
    id: string,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new RemoveRetailer(this.retailerGw);

    useCase.execute(id, presenter, updater);
  }

  public update(
    id: string,
    name: string,
    country: string,
    desId: string,
    file: File | string,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new UpdateRetailer(this.fileGw, this.retailerGw);

    useCase.execute(id, name, country, desId, file, presenter, updater);
  }
}
